import axios from '@/lib/axios';
import { PaymentTaskSubscription, PurchaseOrderContractTaskSubscription } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1020. 支払タスク購読者一覧
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_subscriptions
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};

const createPaymentTaskSubscription = (props: Props): Promise<PaymentTaskSubscription> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_subscriptions`,
    props
  );
};

export const useCreatePaymentTaskSubscription = () => {
  return useMutation({
    mutationFn: createPaymentTaskSubscription,
  });
};
